var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.66669H24.0003C25.0612 6.66669 26.0786 7.08811 26.8288 7.83826C27.5789 8.58841 28.0003 9.60582 28.0003 10.6667V22.6667C28.0003 23.7276 27.5789 24.745 26.8288 25.4951C26.0786 26.2453 25.0612 26.6667 24.0003 26.6667H6.66699C5.60613 26.6667 4.58871 26.2453 3.83857 25.4951C3.08842 24.745 2.66699 23.7276 2.66699 22.6667V10.6667C2.66699 9.60582 3.08842 8.58841 3.83857 7.83826C4.58871 7.08811 5.60613 6.66669 6.66699 6.66669ZM6.66699 8.00002C6.00033 8.00002 5.41366 8.22669 4.96033 8.62669L15.3337 15.3334L25.707 8.62669C25.2537 8.22669 24.667 8.00002 24.0003 8.00002H6.66699ZM15.3337 16.9467L4.17366 9.70669C4.06699 10 4.00033 10.3334 4.00033 10.6667V22.6667C4.00033 23.3739 4.28128 24.0522 4.78137 24.5523C5.28147 25.0524 5.95975 25.3334 6.66699 25.3334H24.0003C24.7076 25.3334 25.3858 25.0524 25.8859 24.5523C26.386 24.0522 26.667 23.3739 26.667 22.6667V10.6667C26.667 10.3334 26.6003 10 26.4937 9.70669L15.3337 16.9467Z",
    fill: "#FFB85C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinEmail);
export default __webpack_public_path__ + "static/media/min-email.a16bf17652207c66af1f18e71f97c63b.svg";
export { ForwardRef as ReactComponent };